import { withMods } from '@epam/uui-core';
import { Avatar as uuiAvatar, AvatarProps } from '@epam/uui-components';

export const Avatar = withMods<AvatarProps>(uuiAvatar, () => []);